export const specialCharactersRegex = /\W/;
export const lowerCaseRegex = /(?=.*[a-z])/;
export const upperCaseRegex = /(?=.*[A-Z])/;
export const numericCaseRegex = /(?=.*[0-9])/;
